import { orderBy } from 'lodash-es'
import { useState } from 'react'

import assertDefined from '@/utils/assertDefined'

import useRealtimeUserLiveHelpRequestsToJoin from '@/components/Worlds/hooks/post/useRealtimeUserLiveHelpRequestsToJoin'

import JoinLiveHelpModal from './internal/JoinLiveHelpModal'

export default function LiveHelpModal(): JSX.Element | null {
  const [showModal, setShowModal] = useState(true)
  const { liveHelpRequests, loading } = useRealtimeUserLiveHelpRequestsToJoin()

  const mostRecentLiveHelpRequest =
    liveHelpRequests.length === 0
      ? null
      : orderBy(liveHelpRequests, request => -request.createdAt.toMillis())[0]

  if (loading === true || mostRecentLiveHelpRequest == null) {
    return null
  }

  const { session, post } = mostRecentLiveHelpRequest

  assertDefined(post, `Post not found for LiveHelpRequest#${mostRecentLiveHelpRequest.id}`)
  assertDefined(session, `Session not found for LiveHelpRequest#${mostRecentLiveHelpRequest.id}`)

  const { hasEnded, userAttemptedJoining } = session

  return userAttemptedJoining === false && hasEnded === false ? (
    <JoinLiveHelpModal
      open={showModal}
      onClose={() => setShowModal(false)}
      liveHelpRequest={mostRecentLiveHelpRequest}
    />
  ) : null
}
